"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingXPTransactionHistoryResponseToJSON = exports.GamingXPTransactionHistoryResponseFromJSONTyped = exports.GamingXPTransactionHistoryResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GamingXPTransactionHistoryResponseFromJSON(json) {
    return GamingXPTransactionHistoryResponseFromJSONTyped(json, false);
}
exports.GamingXPTransactionHistoryResponseFromJSON = GamingXPTransactionHistoryResponseFromJSON;
function GamingXPTransactionHistoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transactions': !(0, runtime_1.exists)(json, 'transactions') ? undefined : (json['transactions'].map(_1.XPTransactionHistoryItemFromJSON)),
        'pagination': !(0, runtime_1.exists)(json, 'pagination') ? undefined : (0, _1.GamingXPTransactionHistoryResponsePaginationFromJSON)(json['pagination']),
        'timeFilter': !(0, runtime_1.exists)(json, 'timeFilter') ? undefined : json['timeFilter'],
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : (new Date(json['endDate'])),
    };
}
exports.GamingXPTransactionHistoryResponseFromJSONTyped = GamingXPTransactionHistoryResponseFromJSONTyped;
function GamingXPTransactionHistoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transactions': value.transactions === undefined ? undefined : (value.transactions.map(_1.XPTransactionHistoryItemToJSON)),
        'pagination': (0, _1.GamingXPTransactionHistoryResponsePaginationToJSON)(value.pagination),
        'timeFilter': value.timeFilter,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
    };
}
exports.GamingXPTransactionHistoryResponseToJSON = GamingXPTransactionHistoryResponseToJSON;
